import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { AiOutlineSend } from "react-icons/ai";
import { format } from "timeago.js";
import { baseURL } from "../../configs/axiosConfig";
import Loading from "../../Util/Loading";

const DashboardMessage = ({ socketId, onClose }) => {
  const userInfo = useSelector((state) => state?.user?.user);
  const seller = userInfo;

  // console.log({ seller });
  const [conversations, setConversations] = useState([]);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [currentChat, setCurrentChat] = useState(null);
  const [userData, setUserData] = useState(null);
  const [open, setOpen] = useState(false);
  const scrollRef = useRef(null);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  // console.log({ socketId });

  // useEffect(() => {
  //   if (!seller) return;
  //   socketId.emit("addUser", seller._id);
  //   socketId.on("getUsers", (users) => {
  //     setOnlineUsers(users);
  //   });
  // }, [seller]);

  // useEffect(() => {
  //   if (seller) {
  //     const sellerId = seller?._id;
  //     socketId.emit("addUser", sellerId);
  //     socketId.on("getUsers", (data) => {
  //       setOnlineUsers(data);
  //     });
  //   }
  // }, [seller]);
  useEffect(() => {
    if (!seller?._id) return;

    socketId.emit("addUser", seller._id);

    const handleGetUsers = (data) => {
      setOnlineUsers(data);
      // console.log("Updated online users:", data);
    };

    socketId.off("getUsers").on("getUsers", handleGetUsers); // safely replace any existing

    return () => {
      socketId.off("getUsers", handleGetUsers);
    };
  }, [socketId, seller?._id]);

  console.log({ onlineUsers });

  useEffect(() => {
    if (!open && conversations.length > 0 && onlineUsers.length > 0) {
      const firstOnlineConv = conversations.find((conv) => {
        const otherUserId = conv.members.find((id) => id !== seller._id);
        return onlineUsers.some((user) => user.userId === otherUserId);
      });

      if (firstOnlineConv) {
        setCurrentChat(firstOnlineConv);
        setUserData(firstOnlineConv.user);
        setOpen(true);
      }
    }
  }, [conversations, onlineUsers, open, seller._id]);

  useEffect(() => {
    const getConversation = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${baseURL}/api/chat/get-all-conversation-seller/${seller._id}`
        );
        const rawConversations = res.data.conversations;

        const updatedConversations = await Promise.all(
          rawConversations.map(async (conv) => {
            const otherUserId = conv.members.find((id) => id !== seller._id);
            const userRes = await axios.post(
              `${baseURL}/api/v1/user/userInfo`,
              { userId: otherUserId }
            );
            return {
              ...conv,
              user: userRes.data.user,
            };
          })
        );

        setConversations(updatedConversations);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };

    getConversation();
  }, [seller]);

  useEffect(() => {
    const getMessages = async () => {
      if (!currentChat) return;
      try {
        const res = await axios.get(
          `${baseURL}/api/message/get-all-messages/${currentChat._id}`
        );
        setMessages(res.data.messages);
      } catch (err) {
        console.error(err);
      }
    };
    getMessages();
  }, [currentChat]);

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  // listenning an event
  const startTypingMessage = () => {
    // console.log("startTypingMessage work");
    if (!currentChat) return;
    const receiverId = currentChat.members.find(
      (member) => member !== seller._id
    );
    console.log({ receiverId });
    socketId.emit("startTypingMessage", {
      senderId: seller._id,
      sendername: seller.name,
      receiverId,
    });
  };

  const stopTypingMessage = () => {
    console.log("stopTypingMessage work");
    if (!currentChat) return;
    const receiverId = currentChat.members.find(
      (member) => member !== seller._id
    );

    console.log({ receiverId });
    socketId.emit("stopTypingMessage", {
      senderId: seller._id,
      sendername: seller.name,
      receiverId,
    });
  };

  const sendMessageHandler = async (e) => {
    e.preventDefault();
    if (!newMessage.trim()) return;
    const message = {
      sender: seller._id,
      text: newMessage,
      conversationId: currentChat._id,
    };
    const receiverId = currentChat.members.find((id) => id !== seller._id);

    socketId.emit("sendMessage", {
      senderId: seller._id,
      receiverId,
      text: newMessage,
    });

    try {
      const res = await axios.post(
        `${baseURL}/api/message/create-new-message`,
        message
      );
      setMessages((prev) => [...prev, res.data.message]);
      setNewMessage("");
    } catch (err) {
      console.error(err);
    }
  };

  const onlineCheck = (chat) => {
    if (!seller?._id) return false;

    const chatMember = chat.members.find(
      (member) => member && member.toString() !== seller._id.toString()
    );

    const isOnline = onlineUsers.some(
      (user) => user?.userId?.toString?.() === chatMember?.toString()
    );

    return isOnline;
  };

  if (loading) return <Loading />;

  return (
    <div className="flex h-screen border border-border">
      {/* Sidebar */}
      <div className="w-[80px] bg-drylight border-r border-border flex flex-col items-center py-4 space-y-4">
        {console.log({ conversations })}
        {conversations.map((conv, i) => {
          const isOnline = onlineCheck(conv);

          // console.log(
          //   `Conversation with ${conv.user?.username}: ${
          //     isOnline ? "Online" : "Offline"
          //   }`
          // );

          return (
            <div key={i} className="relative">
              <img
                src={conv.user?.photo || ""}
                alt="avatar"
                className="w-10 h-10 rounded-full object-cover shadow-md cursor-pointer border border-dry ring-2 ring-dry ring-offset-1 hover:ring-red-400 border border-dry"
                onClick={() => {
                  setCurrentChat(conv);
                  setUserData(conv.user);
                  setOpen(true);
                }}
              />
              <div className="absolute -bottom-1 -right-0.5">
                {isOnline && (
                  <span className="absolute w-3 h-3 rounded-full bg-green-400 opacity-40 animate-pulseRing"></span>
                )}
                <span
                  className={`relative w-3 h-3 rounded-full  block ${
                    isOnline ? "bg-green-500 border-2 border-white" : ""
                  }`}
                ></span>
              </div>
            </div>
          );
        })}
      </div>

      {/* Chat Panel */}
      <div className="flex-1 flex flex-col bg-dry ">
        {open && currentChat ? (
          <>
            {/* Header */}
            <div className="flex items-center justify-between px-4 py-3 bg-redlight text-reddark border border-0">
              <div className="flex items-center space-x-3">
                <img
                  src={userData?.photo || ""}
                  alt="avatar"
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div className="leading-tight">
                  <p className="font-semibold text-sm">
                    {currentChat?.groupTitle || userData?.displayName}
                  </p>
                  {currentChat?.groupTitle && userData?.displayName && (
                    <p className="text-xs text-white/80">
                      {userData.displayName}
                    </p>
                  )}
                </div>
              </div>
              <button
                onClick={onClose}
                className="text-2xl font-bold hover:scale-110 transition"
              >
                ×
              </button>
            </div>

            {/* Messages */}
            <div className="flex-1 overflow-y-auto p-4 space-y-3 border border-black">
              {messages.map((msg, idx) => (
                <div key={idx}>
                  <div
                    className={`flex ${
                      msg.sender === seller._id
                        ? "justify-end"
                        : "justify-start"
                    }`}
                  >
                    <div
                      className={`rounded-xl px-4 py-2 text-white text-sm max-w-xs ${
                        msg.sender === seller._id ? "bg-red-500" : "bg-textGray"
                      }`}
                    >
                      {msg.text}
                    </div>
                  </div>
                  <p
                    className={`text-xs text-gray-500 mt-1 ${
                      msg.sender === seller._id ? "text-right" : "text-left"
                    }`}
                  >
                    {format(msg.createdAt)}
                  </p>
                </div>
              ))}
              <div ref={scrollRef}></div>
            </div>

            {/* Input */}
            <form
              onSubmit={sendMessageHandler}
              className="p-3 bg-white flex items-center gap-2 border-t"
            >
              <input
                type="text"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                onKeyDown={startTypingMessage}
                onKeyUp={stopTypingMessage}
                placeholder="Type your message"
                className="flex-1 p-2 border border-gray-300 rounded-full outline-none"
              />
              <button type="submit">
                <AiOutlineSend className="text-xl text-gray-600" />
              </button>
            </form>
          </>
        ) : (
          <div className="h-full flex flex-col bg-drylight shadow-lg">
            {/* 🆕 Close button header */}
            <div className="flex justify-between items-center p-4 border-b border-border">
              <h2 className="text-base font-semibold text-text">Chat</h2>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-red-500 transition"
              >
                ✕
              </button>
            </div>

            {/* Existing chat body */}
            <div className="flex-1 flex items-center justify-center text-gray-400 bg-dry p-4 text-center">
              Select a contact to start a conversation.
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardMessage;
